import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LayoutConfigService, MenuAsideService, SplashScreenService } from './core/_base/layout';
import { LiveSupportService } from './provider/live-support.service';
import { RequestsService } from './provider/requests.service';
import { TranslationService } from './provider/translation.service';

let OneSignal;

@Component({
  selector: 'body[kt-root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
  loader: boolean;
  private unsubscribe: Subscription[] = [];
  oneSignalId: string;

  constructor(
    public translationService: TranslationService,
    private router: Router,
    private layoutConfigService: LayoutConfigService,
    private splashScreenService: SplashScreenService,
    private supportServ: LiveSupportService,
    private requestServ: RequestsService,
    menuAsideService: MenuAsideService
  ) {
    // register translations
    this.translationService.loadTranslations(['en', 'tr', 'ru', 'es']);
    this.translationService.setLanguage(this.translationService.getSelectedLanguage());

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        menuAsideService.pathname$.next(window.location.pathname);
      }
    });
  }

  ngOnInit(): void {
    /*this.initOneSignal();
*/
    this.loader = this.layoutConfigService.getConfig('loader.enabled');

    const routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('kt-page--loaded');
        }, 500);
      }
    });
    this.unsubscribe.push(routerSubscription);

    if (localStorage.getItem('token_form')) {
      this.requestServ.socketConnect();
      this.supportServ.newMessagesSocket();
      console.log('socket connected');
    }
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(sb => sb.unsubscribe());
  }

  /* initOneSignal() {
     OneSignal = window['OneSignal'] || [];
     OneSignal.push(['init', {
       appId: 'fcfc4cbc-4bc2-4603-9da4-8e7a8f52bd06',
       safari_web_id: 'web.onesignal.auto.31ba082c-c81b-42a5-be17-ec59d526e60e',
       autoRegister: true,
       allowLocalhostAsSecureOrigin: true,
       notifyButton: {
         enable: false,
       },
     }]);

     OneSignal.push(() => {
       OneSignal.on('notificationDisplay', (data) => {
         console.log(data);
       });
     });

     this.checkIfSubscribed();
   }*/

  /*checkIfSubscribed() {
    OneSignal.push(() => {
      /!* These examples are all valid *!/
      OneSignal.isPushNotificationsEnabled((isEnabled) => {
        if (isEnabled) {
          this.getUserID();
        }
      }, () => {
        console.log('Push permission not granted');
      });
    });
  }*/

  /*getUserID() {
    OneSignal.getUserId().then((userId) => {
      this.oneSignalId = userId;
      localStorage.setItem('oneSignalId', this.oneSignalId);
      console.log(this.oneSignalId);
    });
  }*/
}
